import { gql, useQuery } from '@apollo/client'
import { CircularProgress, Stack } from '@mui/material'

import DataroomsTable from './DataroomsTable'
import { DATAROOM_FRAGMENT } from './constants'
import DataroomsContext from './context'

const FIND_DATAROOMS = gql`
  ${DATAROOM_FRAGMENT}
  query FIND_DATAROOMS($filter: JSON!) {
    datarooms: findDatarooms(filter: $filter) {
      ...DataroomFragment
    }
  }
`

function Datarooms() {
  const { loading, error, data } = useQuery(FIND_DATAROOMS, {
    variables: { filter: {} },
  })

  if (loading)
    return (
      <Stack
        sx={{ alignItems: 'center', justifyContent: 'center', height: '100%' }}
      >
        <CircularProgress />
      </Stack>
    )
  if (error) return <p>error...</p>

  const { datarooms } = data

  return (
    <DataroomsContext.Provider value={{ datarooms }}>
      <DataroomsTable />
    </DataroomsContext.Provider>
  )
}

export default Datarooms
